import { useQuery } from '@tanstack/react-query';
import { properties } from '../../realEstateBanner/realEstateProperties/RealEstateNewProperties';
import { StaySmallSmallPropertyCard } from './StaySmallSmallPropertyCard';
import { fetchAllProperties } from '../../../../../../api/propertiesAPI';

export const StaySmallSmallProperties = () => {
  const { data } = useQuery({
    queryKey: ['properties'],
    queryFn: () => fetchAllProperties(),
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {data?.properties.map((property) => (
        <StaySmallSmallProperty
          key={property?.propertyID}
          property={property}
        />
      ))}
    </div>
  );
};

const StaySmallSmallProperty = ({ property }) => {
  return <StaySmallSmallPropertyCard property={property} />;
};
